import React, { useMemo, useState } from "react";
import { Users, FileSpreadsheet, Plug } from "lucide-react";
import { cn } from "../../../lib/utils";
import UploadCsvTab from "./UploadCsvTab";
import UsersTab from "./UsersTab";
import VibeConnectTab from "./VibeConnectTab";
import { useProfileSetup } from "../../../contexts/ProfileContext";

const TABS = [
  { id: "upload-csv", label: "Upload Contacts", icon: FileSpreadsheet },
  { id: "users", label: "Users", icon: Users },
  { id: "integrations", label: "Integrations", icon: Plug },
];

export default function AdminView() {
  const { userRole } = useProfileSetup();
  const [activeTab, setActiveTab] = useState("users");

  const isSuperAdmin = useMemo(
    () => userRole === "superadmin",
    [userRole]
  );

  const isAdmin = useMemo(
    () => userRole === "admin" || userRole === "superadmin",
    [userRole]
  );

  const visibleTabs = useMemo(() => {
    return TABS.filter((tab) => {
      if (tab.id === "upload-csv") return isSuperAdmin;
      if (tab.id === "integrations") return isAdmin;
      return true;
    });
  }, [isSuperAdmin, isAdmin]);

  const safeActiveTab = useMemo(() => {
    const visibleIds = visibleTabs.map((t) => t.id);
    if (!visibleIds.includes(activeTab)) return visibleIds[0] ?? "users";
    return activeTab;
  }, [activeTab, visibleTabs]);

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Admin</h1>

      <nav className="flex gap-1" aria-label="Admin tabs">
        {visibleTabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            className={cn(
              "flex items-center gap-3 rounded-lg px-3 py-2 text-primary transition-all hover:bg-accent hover:text-primary",
                safeActiveTab === id
                ? "bg-accent text-accent-foreground"
                : "text-muted-foreground"
            )}
            onClick={() => setActiveTab(id)}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        ))}
      </nav>

      {safeActiveTab === "upload-csv" && isSuperAdmin && <UploadCsvTab />}
      {safeActiveTab === "users" && <UsersTab />}
      {safeActiveTab === "integrations" && isAdmin && <VibeConnectTab />}
    </div>
  );
}
